import React from 'react';
import { Button } from './Button';
import { scrollToElement } from '../utils/scrollToElement';
export function Hero() {
  return <section className="relative min-h-[85vh] flex items-center pt-24 pb-12 overflow-hidden" data-id="element-80">
      <div className="max-w-7xl mx-auto px-6 md:px-12 w-full grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-81">
        <div className="order-2 lg:order-1 flex flex-col items-start z-10" data-id="element-82">
          <span className="uppercase tracking-[0.2em] text-xs text-ink-light mb-6 block" data-id="element-83">
            Un nuevo capítulo en el bienestar femenino
          </span>

          <h1 className="font-serif text-4xl sm:text-5xl md:text-7xl leading-[1.1] text-ink mb-6 md:mb-8" data-id="element-84">
            Recupera tu <em className="italic text-sand-dark" data-id="element-85">energía</em>,
            balance y <em className="italic text-sand-dark" data-id="element-86">claridad</em>.
          </h1>

          <p className="text-base md:text-xl text-ink-light font-light leading-relaxed mb-8 md:mb-10 max-w-md" data-id="element-87">
            El método del 1% respaldado por la ciencia para equilibrar tus
            hormonas de forma natural, sin dietas extremas ni agotamiento.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-6" data-id="element-88">
            <Button onClick={() => scrollToElement('precio')} data-id="element-89">
              Acceso Inmediato
            </Button>
            <a href="#method" className="text-sm uppercase tracking-widest text-ink-light hover:text-ink transition-colors border-b border-transparent hover:border-ink pb-1" data-id="element-90">
              Descubre el Método
            </a>
          </div>
        </div>

        <div className="order-1 lg:order-2 relative h-[40vh] sm:h-[50vh] lg:h-[80vh] w-full" data-id="element-91">
          <img src="https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=70&w=640&auto=format&fit=crop" srcSet="https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=70&w=480&auto=format&fit=crop 480w, https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=70&w=800&auto=format&fit=crop 800w, https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=70&w=1200&auto=format&fit=crop 1200w" sizes="(max-width: 1024px) 100vw, 50vw" alt="Mujer radiante con la luz del sol reflejándose en su rostro" width={1200} height={1500}
        // @ts-expect-error fetchpriority is valid HTML but typed loosely in React
        fetchpriority="high" loading="eager" decoding="async" className="relative w-full h-full object-cover rounded-t-full lg:rounded-t-[200px] lg:rounded-b-none shadow-soft-lg bg-sage/20" data-id="element-92" />
        </div>
      </div>
    </section>;
}